import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { BrowserTracing, init } from '@sentry/browser';
import { isExpectedSignalRError, SIGNALR_TIMEOUT_MESSAGE } from '@/lib/signalr';

init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  ignoreErrors: [SIGNALR_TIMEOUT_MESSAGE],
  integrations: [
    new BrowserTracing({
      tracePropagationTargets: [/^http:\/\/signage-app-admin.s3-website.eu-north-1.amazonaws.\.com/],
    }),
  ],
  beforeSend(event, hint) {
    if (
      isExpectedSignalRError(hint.originalException) ||
      isExpectedSignalRError(hint.syntheticException) ||
      event.exception?.values?.some(v => isExpectedSignalRError(v?.value))
    ) {
      return null;
    }

    return event;
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
